import { CSSProperties, ReactNode } from 'react';

import { GoogleMap } from '@react-google-maps/api';

import GoogleMapsScriptProvider from './GoogleMapsScriptProvider';

/** More info: https://react-google-maps-api-docs.netlify.app/ */

interface WrapperGoogleMapProps {
    googleMapsApiKey: string;
    id?: string;
    mapContainerClassName?: string | undefined;
    mapContainerStyle?: CSSProperties | undefined;
    options?: google.maps.MapOptions | undefined;
    /** The initial Map center. */
    center?: google.maps.LatLng | google.maps.LatLngLiteral | undefined;
    /** The initial Map zoom level. Required. Valid values: Integers between zero, and up to the supported maximum zoom level. */
    zoom?: number | undefined;
    children?: ReactNode | undefined;
    /** This callback is called when the map instance has loaded. It is called with the map instance. */
    onLoad?: ((map: google.maps.Map) => void | Promise<void>) | undefined;
    /** This callback is called when the component unmounts. It is called with the map instance. */
    onUnmount?: ((map: google.maps.Map) => void | Promise<void>) | undefined;
}

const WrapperGoogleMap = ({
    googleMapsApiKey,
    id,
    mapContainerClassName,
    mapContainerStyle,
    options,
    center,
    zoom = 15,
    children,
    onLoad,
    onUnmount,
}: WrapperGoogleMapProps): JSX.Element => {
    return (
        <GoogleMapsScriptProvider googleMapsApiKey={googleMapsApiKey}>
            <GoogleMap
                id={id}
                mapContainerClassName={mapContainerClassName}
                mapContainerStyle={mapContainerStyle}
                options={options}
                center={center}
                zoom={zoom}
                onLoad={onLoad}
                onUnmount={onUnmount}
            >
                {children}
            </GoogleMap>
        </GoogleMapsScriptProvider>
    );
};

export default WrapperGoogleMap;
